import React, {useState} from 'react';
import {
   GridCol, GridRow, SearchBox,
} from 'govuk-react';
import {
    HeaderContainer,
    InnerWrapper,
    SearchForm,
} from './styles';

import Dropdown from '../Dropdown'

function TopNav() {

    const [page, setPage] = useState(undefined);

    const handleMenuChange = (e) => {
        setPage(e);
        console.log('inside header', e)
    };

    return (
        <HeaderContainer>
            <InnerWrapper>
                <a href='http://ontario.ca'>
                    <img  src="assets/images/logo-ontario@2x.png" alt="Government of Ontario" />
                </a>
                <SearchForm>
                    <GridRow>
                        <GridCol>
                            <SearchBox placeholder="Search Ontario.ca" />
                        </GridCol>
                    </GridRow>
                </SearchForm>
                <Dropdown
                    placeholder="Select Page"
                    value={page}
                    onChange={(v) =>  handleMenuChange(v)}
                    options={[
                        {title: 'Page Example 1', url: 'tomato'},
                        {title: 'Page Example 2', url: 'soy'},
                        {title: 'Page Example 3', url: 'mint'},
                        {title: 'Custom Elements 1', url: 'mustard'},
                        {title: 'Custom Elements 2', url: 'mustard'},]}
                />
            </InnerWrapper>
        </HeaderContainer>
    );
}

export default TopNav;